import React from "react";
import { useNavigate, Navigate } from "react-router-dom";
import ClientCreationWizard from "../components/ClientCreationWizard";
import { useAuth } from "../context/AuthContext";

const CreateClientPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Check if user is chief-admin
  const userRole = user?.role_name || user?.role;
  const normalizeRole = (role) =>
    role ? role.toLowerCase().replace(/[_\s-]/g, "-") : null;
  const normalizedUserRole = normalizeRole(userRole);
  const isUserChiefAdmin = normalizedUserRole === "chief-admin";

  // Redirect non-chief-admin users
  if (!isUserChiefAdmin) {
    return <Navigate to="/projects" replace />;
  }

  const handleClose = () => {
    navigate("/clients");
  };

  const handleSuccess = async () => {
    // Navigate back to clients page after successful creation
    navigate("/clients", { replace: true });
  };

  return (
    <ClientCreationWizard
      isOpen={true}
      onClose={handleClose}
      onSuccess={handleSuccess}
      fullPage={true}
    />
  );
};

export default CreateClientPage;
